
  // ============================================================
  // CONFIGURATION — replace these three values before going live
  // ============================================================
  var SPER_EJS_KEY  = 'Aq7MSsGsfCJr5Lc3_';
  var SPER_EJS_SVC  = 'service_tpehjjf';
  var SPER_EJS_TPL  = 'template_deeb8px';
  var SPER_SHOP_EMAIL = 'repairs@smartphoneer.co.za';
  // ============================================================

  emailjs.init(SPER_EJS_KEY);

  var sperState = {
    make: '', model: '', issues: [], notes: '',
    fname: '', lname: '', phone: '', email: '', delivery: ''
  };
  var sperCur = 1;

  function sperToggleIssue(el) {
    el.classList.toggle('sel');
    var t = el.textContent.trim();
    if (el.classList.contains('sel')) {
      if (sperState.issues.indexOf(t) === -1) sperState.issues.push(t);
    } else {
      sperState.issues = sperState.issues.filter(function(i) { return i !== t; });
    }
  }

  function sperPickDel(el) {
    document.querySelectorAll('.sper-dopt').forEach(function(d) { d.classList.remove('sel'); });
    el.classList.add('sel');
    sperState.delivery = el.getAttribute('data-d');
    document.getElementById('sperAddrBox').style.display =
      sperState.delivery.indexOf('deliver to SmartPhoneER') !== -1 ? 'block' : 'none';
  }

  function sperShowErr(id) { document.getElementById(id).style.display = 'block'; }
  function sperHideErr(id) { document.getElementById(id).style.display = 'none'; }

  function sperValidate(n) {
    if (n === 1) {
      sperHideErr('sperE1');
      var mk = document.getElementById('sperMake').value;
      var mo = document.getElementById('sperModel').value.trim();
      if (!mk || !mo) { sperShowErr('sperE1'); return false; }
      sperState.make = mk;
      sperState.model = mo;
      return true;
    }
    if (n === 2) {
      sperHideErr('sperE2');
      if (sperState.issues.length === 0) { sperShowErr('sperE2'); return false; }
      sperState.notes = document.getElementById('sperIssueNotes').value;
      return true;
    }
    if (n === 3) {
      sperHideErr('sperE3');
      var fn = document.getElementById('sperFname').value.trim();
      var ln = document.getElementById('sperLname').value.trim();
      var ph = document.getElementById('sperPhone').value.trim();
      var em = document.getElementById('sperEmail').value.trim();
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);
      if (!fn || !ln || !ph || !emailOk) { sperShowErr('sperE3'); return false; }
      sperState.fname = fn;
      sperState.lname = ln;
      sperState.phone = ph;
      sperState.email = em;
      return true;
    }
    if (n === 4) {
      sperHideErr('sperE4');
      if (!sperState.delivery) { sperShowErr('sperE4'); return false; }
      return true;
    }
    return true;
  }

  function sperGo(n) {
    if (n > sperCur && !sperValidate(sperCur)) return;

    var from = sperCur;
    document.getElementById('sperP' + from).classList.remove('active');

    var fd = document.getElementById('sperD' + from);
    fd.classList.remove('active');
    if (n > from) {
      fd.classList.add('done');
      fd.textContent = '✓';
      document.getElementById('sperL' + from).classList.add('done');
    } else {
      fd.classList.remove('done');
      fd.textContent = from;
      document.getElementById('sperL' + from).classList.remove('done');
    }

    sperCur = n;
    document.getElementById('sperP' + sperCur).classList.add('active');
    var cd = document.getElementById('sperD' + sperCur);
    cd.classList.add('active');
    cd.classList.remove('done');
    cd.textContent = sperCur;

    if (n === 5) sperFillConfirm();
  }

  function sperFillConfirm() {
    document.getElementById('sperCDev').textContent = sperState.make + ' ' + sperState.model;
    document.getElementById('sperCIss').textContent = sperState.issues.join(', ') +
      (sperState.notes ? ' · Notes: ' + sperState.notes : '');
    document.getElementById('sperCCust').textContent =
      sperState.fname + ' ' + sperState.lname + ' · ' + sperState.phone + ' · ' + sperState.email;
    document.getElementById('sperCDel').textContent = sperState.delivery;
  }

  function sperSubmit() {
    sperHideErr('sperE5');
    sperHideErr('sperESubmit');

    if (!document.getElementById('sperAgree').checked) {
      sperShowErr('sperE5');
      return;
    }

    var btn = document.getElementById('sperSubBtn');
    btn.disabled = true;
    btn.textContent = 'Sending...';

    var sperRef = Math.random().toString(36).substring(2, 7).toUpperCase();

    emailjs.send(SPER_EJS_SVC, SPER_EJS_TPL, {
      booking_ref:  sperRef,
      make:       sperState.make,
      model:      sperState.model,
      issues:     sperState.issues.join(', '),
      notes:      sperState.notes || 'None',
      name:       sperState.fname + ' ' + sperState.lname,
      email:      sperState.email,
      phone:      sperState.phone,
      delivery:   sperState.delivery,
      shop_email: SPER_SHOP_EMAIL,
      reply_to:   sperState.email
    }).then(function() {
      document.getElementById('sperP5').classList.remove('active');
      document.getElementById('sperPSuc').classList.add('active');
      document.getElementById('sperProg').style.display = 'none';
    }).catch(function() {
      sperShowErr('sperESubmit');
      btn.disabled = false;
      btn.textContent = 'Confirm booking';
    });
  }